import { CloseCircleOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

export const ErrorIcon = styled(CloseCircleOutlined)`
  color: #ff4d4f;
  font-size: 20px;
`;
